import { TheMarketCardList } from './card-list';
import { TheMarketListFilterBar } from './filter-bar';

export const TheMarketList = () => {
  return (
    <section className="w-full">
      <TheMarketListFilterBar />
      <TheMarketCardList />
    </section>
  );
};
